export const en_US = {
    "PREFIX": {
        "QUESTION": "Question",
        "QUESTION-PART": "Question",
        "PRE-RELEASE": "Pre-Release",
        "JOURNAL": "Journal"
    },
    "CONTENT": {
        "MARK": "mark{{totalMarks > 1 && 's' || ''}}"
    }
};